import angular from 'angular'

/**
 * Helper directive for vdTracking.trackLinks (see vend.js). Listens for click events on links within the provided
 * element.
 *
 * @module vend.ui.vdTrackLinks
 */
angular.module('vend.ui').directive('vdTrackLinks', function (vdTracking) {
  return {
    restrict: 'A',
    scope: {
      /**
       * @param {Object} vdTrackLinks
       *        Data to be passed to the trackLinks method.
       *
       *        @param {String} vdTrackLinks.moduleName
       *               The module name for the UBE.
       *
       *        @param {String} [vdTrackLinks.eventName]
       *               The name of the event.
       *
       *        @param {Object} [vdTrackLinks.metadata]
       *               Additional meta data about the event, e.g. 'feature' or 'source'.
       */
      vdTrackLinks: '=',
    },
    link(scope, $element) {
      const config = angular.copy(scope.vdTrackLinks || {})
      config.selector = $element
      vdTracking.trackLinks(config)
    },
  }
})
